import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonAPIService } from '../commonAPI.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { buildUrlQuery } from '../url-utils';
import { ProductHierarchyObj } from '@shared/components/recipes-form-header/classifications/catalog/catalog.component';

@Injectable({
  providedIn: 'root',
})
export class ProductReferencesService extends CommonAPIService {
  constructor(http: HttpClient, configService: ConfigService) {
    super(configService, http);
  }

  getHierarchy(key: string, market?: string, useCDN?: boolean): Observable<ProductHierarchyObj> {
    const param = buildUrlQuery({
      key,
      market,
      UseCDN: useCDN,
    });
    const url = 'productReferences/hierarchy' + param;
    return this.get(url);
  }
}
